module.exports = "/assets/images/577865e4990460997d88f146075b225d.png";